import {
  VendorBankDetail,
  VendorDetailState,
  CommercialDetail
} from "../../reducers/vendor/VendorDetailReducer";

export type VendorDetailAction =
  | {
      type: "ON_CHANGE_VENDOR_DETAIL_DATA";
      payload: [input: string, value: any];
    }
  | {
      type: "ON_REMOVE_VENDOR_DETAIL_SETTLEMENT_CURRENCY";
      payload: [value: string];
    }
  | {
      type: "ON_REMOVE_VENDOR_DETAIL_PREFFERED_PAYMENT_METHOD";
      payload: [value: string];
    }
  | {
      type: "ON_ADD_VENDOR_DETAIL_MOBILENUMBER";
      payload: [mobileNumber: string, isChecked: boolean];
    }
    | {
      type: "ON_UPDATE_CHECKED_STATUS_VENDOR_DETAIL_MOBILE";
      payload: [mobileNo: string, isChecked: boolean];
    }    
  | {
      type: "ON_REMOVE_VENDOR_DETAIL_MOBILE_NUMBER";
      payload: [value: string];
    }
  | {
      type: "ON_ADD_VENDOR_DETAIL_EMAILNOTE";
      payload: [email: string, note: string];
    }
  | {
      type: "ON_REMOVE_VENDOR_DETAIL_EMAILNOTE";
      payload: [email: string];
    }
  | {
      type: "ON_STATUS_UPDATE_VENDOR_DETAIL";
      payload: [status: boolean];
    }
  | {
      type: "ON_SUCCESS_VENDOR_DETAIL_GET";
      payload: VendorDetailState;
    }
  | {
      type: "RESET_DETAIL";
      payload: [];
    }
  | {
      type: "ON_ORDERCURRENCY_UPDATE_VENDOR_DETAIL";
      payload: [ordercurrency: string];
    }
  | {
      type: "ON_ADD_VENDOR_DETAIL_BANKDETAIL";
      payload: [bankdetail: VendorBankDetail];
    }
  | {
      type: "ON_EDIT_VENDOR_DETAIL_BANKDETAIL";
      payload: [bankdetail: VendorBankDetail];
    }
  | {
      type: "ON_CLEAR_VENDOR_BANK_FIELD";
      payload: [id: number, property: string];
    }
  | {
      type: "ON_REMOVE_VENDOR_DETAIL_BANKDETAIL";
      payload: [bankdetail: VendorBankDetail];
    }
  | {
      type: "ON_REMOVE_VENDOR_DETAIL_COMMERCIALDETAIL";
      payload: [commercialdetail: CommercialDetail];
    };

function updateDataField(input: string, value: any): VendorDetailAction {
  return {
    type: "ON_CHANGE_VENDOR_DETAIL_DATA",
    payload: [input, value],
  };
}

function clearBankField(id: number, property: string): VendorDetailAction {
  return {
    type: "ON_CLEAR_VENDOR_BANK_FIELD",
    payload: [id, property],
  };
}

function removeFromSettlementCurrency(
  settlecurencycode: string
): VendorDetailAction {
  return {
    type: "ON_REMOVE_VENDOR_DETAIL_SETTLEMENT_CURRENCY",
    payload: [settlecurencycode],
  };
}

function removeFromPrefPayMethod(
  paymentmethodcode: string
): VendorDetailAction {
  return {
    type: "ON_REMOVE_VENDOR_DETAIL_PREFFERED_PAYMENT_METHOD",
    payload: [paymentmethodcode],
  };
}

function addMobileNumber(mobnum: string): VendorDetailAction {
  return {
    type: "ON_ADD_VENDOR_DETAIL_MOBILENUMBER",
    payload: [mobnum, false],
  };
}

function removeMobileNumber(mobnum: string): VendorDetailAction {
  return {
    type: "ON_REMOVE_VENDOR_DETAIL_MOBILE_NUMBER",
    payload: [mobnum],
  };
}

function setCheckMobileNo(mobileNo: string, checkedStatus: boolean): VendorDetailAction {
  return {
    type: "ON_UPDATE_CHECKED_STATUS_VENDOR_DETAIL_MOBILE",
    payload: [mobileNo, checkedStatus],
  };
}

function addEmailNote(email: string, note: string): VendorDetailAction {
  return {
    type: "ON_ADD_VENDOR_DETAIL_EMAILNOTE",
    payload: [email, note],
  };
}

function removeEmailNote(email: string): VendorDetailAction {
  return {
    type: "ON_REMOVE_VENDOR_DETAIL_EMAILNOTE",
    payload: [email],
  };
}

function updateSubmitStatus(status: boolean): VendorDetailAction {
  return {
    type: "ON_STATUS_UPDATE_VENDOR_DETAIL",
    payload: [status],
  };
}

function updateVendorDetails(vendor: VendorDetailState): VendorDetailAction {
  return {
    type: "ON_SUCCESS_VENDOR_DETAIL_GET",
    payload: vendor,
  };
}

function resetVendorDetails(): VendorDetailAction {
  return {
    type: "RESET_DETAIL",
    payload: [],
  };
}

function updateOrderCurrency(ordercurrency: string): VendorDetailAction {
  return {
    type: "ON_ORDERCURRENCY_UPDATE_VENDOR_DETAIL",
    payload: [ordercurrency],
  };
}

function addBankDetails(vendorBank: VendorBankDetail): VendorDetailAction {
  return {
    type: "ON_ADD_VENDOR_DETAIL_BANKDETAIL",
    payload: [vendorBank],
  };
}

function editBankDetails(vendorBank: VendorBankDetail): VendorDetailAction {
  return {
    type: "ON_EDIT_VENDOR_DETAIL_BANKDETAIL",
    payload: [vendorBank],
  };
}

function removeBankDetails(vendorBank: VendorBankDetail): VendorDetailAction {
  return {
    type: "ON_REMOVE_VENDOR_DETAIL_BANKDETAIL",
    payload: [vendorBank],
  };
}

function removeCommercialDetails(vendorCommercial: CommercialDetail): VendorDetailAction {
  return {
    type: "ON_REMOVE_VENDOR_DETAIL_COMMERCIALDETAIL",
    payload: [vendorCommercial],
  };
}
export const VendorDetailActions = {
  updateDataField,
  removeFromSettlementCurrency,
  addMobileNumber,
  removeMobileNumber,
  addEmailNote,
  removeEmailNote,
  updateSubmitStatus,
  updateVendorDetails,
  //updateBankDetails,
  resetVendorDetails,
  //updateBenificiaryAccName,
  updateOrderCurrency,
  addBankDetails,
  editBankDetails,
  removeBankDetails,
  removeFromPrefPayMethod,
  setCheckMobileNo,
  clearBankField,
  removeCommercialDetails
};
